export const CREATE_BOOKING_ID = 'CREATE_BOOKING_ID'

export const GET_BOOKING_ID = 'GET_BOOKING_ID'

export const SET_BOOKING_DETAILS = 'SET_BOOKING_DETAILS'